<template>
  <Card
    v-if="offerHighlight"
    class="rebate-highlight"
    v-bind="card"
    :tabindex="!!modal ? 0 : undefined"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { openModal } from '~/composables/modal';
import { useOfferStore } from '~/stores/offers';
import { Card } from '@i22team/td-longtail-vue-components';

export type RebateHighlightProps = {
  articleNumber?: string;
};

const props = withDefaults(defineProps<RebateHighlightProps>(), {
  articleNumber: undefined,
});

const { offerBadges } = storeToRefs(useOfferStore());

const offerHighlight = computed(() =>
  offerBadges.value.find((item) => item.articleNumber === props.articleNumber && item.card)
);

const modal = computed(() => offerHighlight.value?.modal);

const card = computed(() => {
  const e = offerHighlight.value?.card;
  return e ? { ...e, isLink: !!modal.value } : undefined;
});

const handleClick = () => {
  if (!modal.value) return;
  openModal(modal.value);
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.rebate-highlight {
  margin-bottom: 1rem;
}
</style>
